<div
  *ngIf="{ store: store$ | async, isSelected: isSelected$ | async } as data"
  class="facet mt-0 mb-0 mb-lg-2"
  [class.mb-lg-5]="!data.store?.pickupEnabled">
  <div
    class="facet__header d-none d-lg-flex align-items-center"
    [attr.aria-label]="'rrs.storeLocator.shopStore' | cxTranslate"
    tabindex="0">
    <h5 class="facet__title text-uppercase fw-light mb-0">
      {{ 'rrs.storeLocator.shopStore' | cxTranslate }}
    </h5>
  </div>
  <div class="facet__body--store">
    <div
      class="facet__value bg-body w-100 text-start"
      (click)="handleFacetClick()"
      (keydown.enter)="handleFacetClick()">
      <div class="form-check">
        <input
          id="myStoreFacet"
          class="form-check-input"
          data-cy="myStoreCheckbox"
          tabindex="0"
          [class.selected]="data.isSelected"
          type="checkbox"
          value=""
          [attr.aria-checked]="data.isSelected"
          [checked]="data.isSelected"
          (click)="handleCheckboxClick($event)"
          (keydown.enter)="handleCheckboxClick($event)" />
        <label
          for="myStoreFacet"
          class="facet-value__label d-flex flex-column align-items-start text-truncate">
          <span
            class="facet-value__title d-block w-100 fw-bold text-truncate"
            >{{
              data.store?.displayName ??
                ('rrs.storeLocator.findStore' | cxTranslate) | titlecase
            }}</span
          >
          <span
            class="facet-value__info text-truncate w-100"
            *ngIf="!data.store; else storeOpenState"
            >{{ 'rrs.storeLocator.filterBy' | cxTranslate }}</span
          >
          <ng-template #storeOpenState>
            <span
              *ngIf="data.store | storeOpenState as openState"
              class="text-truncate w-100"
              [ngClass]="openState.isOpen ? 'text-success' : 'text-danger'">
              {{ openState.key | cxTranslate: openState.params ?? {} }}
            </span>
          </ng-template>
        </label>
      </div>
      <div
        *ngIf="data.store?.pickupEnabled || data.store?.curbsidePickupEnabled"
        class="pickup-info">
        <span class="fst-italic">
          {{
            data.store?.pickupEnabled && data.store?.curbsidePickupEnabled
              ? ('rrs.storeLocator.inStoreCurbsidePickup' | cxTranslate)
              : data.store?.pickupEnabled
              ? ('rrs.storeLocator.inStorePickup' | cxTranslate)
              : data.store?.curbsidePickupEnabled
              ? ('rrs.storeLocator.inStoreCurbsidePickup' | cxTranslate)
              : ''
          }}
        </span>
      </div>
    </div>
  </div>
</div>
